export const parseStringToBoolean = (raw?: string): boolean =>
  raw?.toLowerCase() === "true";
